import { render, staticRenderFns } from "./gxh.vue?vue&type=template&id=3467a972&scoped=true&"
import script from "./gxh.vue?vue&type=script&lang=js&"
export * from "./gxh.vue?vue&type=script&lang=js&"
import style0 from "./gxh.vue?vue&type=style&index=0&id=3467a972&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3467a972",
  null
  
)

export default component.exports